import { Button } from "@/components/ui/button";
import { ArrowRight, ShoppingBag } from "lucide-react";
import { Link } from "react-router-dom";
import atrium from "@/assets/proton-atrium-cinematic.jpg";

export function CompanyHero() {
  return (
    <section className="cinematic-home relative isolate min-h-[calc(100svh-4rem)] overflow-hidden border-b border-accent/20">
      <img src={atrium} alt="Futuristic Proton atrium with two illuminated portals" loading="eager" width={1920} height={1080} className="absolute inset-0 h-full w-full object-cover" />
      <div className="cinematic-home-shade absolute inset-0" aria-hidden="true" />
      <div className="relative z-10 mx-auto flex min-h-[calc(100svh-4rem)] max-w-7xl flex-col items-center justify-center px-4 py-16 text-center sm:px-8">
        <p className="text-xs font-semibold uppercase text-accent sm:text-sm">Proton Health Labs™</p>
        <h1 className="mt-4 max-w-5xl font-display text-5xl leading-[0.9] text-foreground sm:text-7xl lg:text-8xl">Be a Proton™</h1>
        <p className="mt-3 font-heading text-2xl font-bold uppercase text-accent sm:text-4xl">Always Positive.</p>
        <p className="mt-6 max-w-2xl text-sm leading-relaxed text-foreground/80 sm:text-lg">
          A veteran-founded positive lifestyle supplement company behind Brain Charge™, transparent, stimulant-free cognitive support for focus, memory, and mental stamina.
        </p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Button
              asChild
              size="lg"
              className="h-12 rounded-md bg-primary px-8 text-sm font-bold uppercase text-primary-foreground shadow-2xl shadow-primary/20 hover:bg-primary/90 sm:h-14"
            >
              <Link to="/products/brain-charge">
                <ShoppingBag className="mr-2 h-4 w-4" />
                Shop Brain Charge
              </Link>
            </Button>
            <Button
              asChild
              size="lg"
              variant="outline"
              className="h-12 rounded-md border-border bg-background/40 px-8 text-sm font-bold uppercase text-foreground hover:bg-muted sm:h-14"
            >
              <Link to="/about">
                Our Story
                <ArrowRight className="ml-2 h-4 w-4" />
              </Link>

            </Button>
        </div>
        <div className="mt-7 grid w-full max-w-3xl grid-cols-2 gap-px overflow-hidden border border-border/60 bg-border/60 text-[11px] font-semibold uppercase text-foreground/80 sm:grid-cols-4 sm:text-xs">
          {["Stimulant-Free", "No Proprietary Blends", "Made & Packaged in USA", "Veteran-Founded"].map((fact) => (
            <div key={fact} className="flex min-h-12 items-center justify-center bg-background/65 px-2 supports-[backdrop-filter]:backdrop-blur-md">{fact}</div>
          ))}
        </div>
      </div>
    </section>
  );
}